import { ADHOC_TEST_INSTRUCTIONS_MAX_LENGTH } from '@chatsdet/types';

export { ADHOC_TEST_INSTRUCTIONS_MAX_LENGTH };

const numberFormatter = new Intl.NumberFormat('en-US');

export const ADHOC_TEST_INSTRUCTIONS_REQUIRED_MESSAGE = 'Instructions are required';

export function getExploratoryInstructionLength(instructions: string): number {
  return instructions.trim().length;
}

export function getExploratoryInstructionsLimitLabel(): string {
  return numberFormatter.format(ADHOC_TEST_INSTRUCTIONS_MAX_LENGTH);
}

export function getExploratoryInstructionsTooLongMessage(): string {
  return `Instructions must be ${getExploratoryInstructionsLimitLabel()} characters or fewer`;
}

export function getExploratoryInstructionsError(instructions: string): string | null {
  const length = getExploratoryInstructionLength(instructions);
  if (length === 0) return ADHOC_TEST_INSTRUCTIONS_REQUIRED_MESSAGE;
  if (length > ADHOC_TEST_INSTRUCTIONS_MAX_LENGTH) {
    return getExploratoryInstructionsTooLongMessage();
  }
  return null;
}
